/*
 * Metallic Gold / Metallic Silver accent-color fix for the custom frame
 * builder (sections/updated-framing-template.liquid).
 *
 * The builder's "Accent Color" dropdown applies a flat solid CSS border
 * color to the preview image (e.g. border: 10px solid #D4AF37). A flat
 * hex color alone just reads as plain gold/silver, not "metallic".
 *
 * This watches the preview image for border-color changes and, whenever
 * the selected color is Metallic Gold (D4AF37) or Metallic Silver
 * (C0C0C0), layers a multi-stop gradient on top via border-image to
 * simulate a reflective metallic sheen. Any other color falls back to
 * the normal flat border untouched.
 *
 * Implemented as an independent observer (rather than editing the large
 * legacy builder file directly) so it works regardless of which code
 * path inside that file sets the border (initial load, window resize,
 * or the accent-color change handler).
 */
(function () {
  var metallicGradients = {
    "D4AF37": "linear-gradient(135deg, #7a5c17 0%, #e8c766 18%, #fff6d0 34%, #d4af37 50%, #9c7a22 66%, #f3dd8e 82%, #7a5c17 100%)",
    "C0C0C0": "linear-gradient(135deg, #6b6b6b 0%, #dedede 18%, #ffffff 34%, #c0c0c0 50%, #8f8f8f 66%, #e6e6e6 82%, #6b6b6b 100%)"
  };

  function rgbToHex(rgb) {
    if (!rgb) return null;
    var m = rgb.match(/rgba?\(\s*(\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return null;
    function h(n) {
      return ("0" + parseInt(n, 10).toString(16)).slice(-2);
    }
    return (h(m[1]) + h(m[2]) + h(m[3])).toUpperCase();
  }

  function enhance(img) {
    if (!img) return;

    var hex = null;
    try {
      hex = rgbToHex(window.getComputedStyle(img).borderTopColor);
    } catch (e) {
      /* no-op */
    }

    var gradient = hex ? metallicGradients[hex] : null;
    var desired = gradient ? gradient + " 1" : "none";

    if (img.style.borderImage !== desired) {
      img.style.borderImage = desired;
    }
  }

  function init() {
    var img =
      document.querySelector(".inner img.previewImg") ||
      document.querySelector(".inner img");
    if (!img) return;

    enhance(img);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === "style") {
          enhance(img);
          break;
        }
      }
    });
    observer.observe(img, { attributes: true, attributeFilter: ["style"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
